import { useEffect, useState, useMemo, useContext } from 'react'
import { FileUploader } from "react-drag-drop-files"
import _ from 'lodash'

import Typography from '@mui/material/Typography'
import { AppContext } from '/providers/app-context'
import { PassContext } from '/components/editor/pass-context'

import { uploadClientImage } from '/providers/templates-api'

const AppleDropTargetContent = (
  <div style={{ borderRadius: 10, border: "2px dashed white", paddingLeft: 40, paddingRight: 40, paddingTop: 10, paddingBottom: 10 }}>
    <div className='flex flex-row justify-between text-sm'>
      <div>
        <div className='mb-3'>Upload a new image</div>
        <div>Click to select image, or drag an image here</div>
        <div>["png", "jpg", "jpeg"]</div>
      </div>
      <div>1125x432px</div>
    </div>
  </div>
)

const GoogleDropTargetContent = (
  <div style={{ borderRadius: 10, border: "2px dashed white", paddingLeft: 40, paddingRight: 40, paddingTop: 10, paddingBottom: 10 }}>
    <div className='flex flex-row justify-between text-sm'>
      <div>
        <div className='mb-3'>Upload a new image</div>
        <div>Click to select image, or drag an image here</div>
        <div>["png", "jpg", "jpeg"]</div>
      </div>
      <div>1132x336px</div>
    </div>
  </div>
)

const StampImages = ({ clientId, scannerData, setPrevButtonState, setNextButtonState, templateId, template, setTemplate, model, objectData, classData, setClassdata, setObjectData, applePassType, googlePassType, instanceData, setScannerData, setInstanceData, scannerInstanceData, setScannerInstanceData }) => {

  const [uploads, setUploads] = useState(0)
  const { apiSource, apiKeys, setProcessing } = useContext(AppContext)



  const appleImageItem = index => {

    const filename = `apple-stamp-${index}.png`

    const handleImageUpload = async file => {
      const reader = new FileReader()
      reader.onloadend = async () => {
        const s3_url = await doUploadToS3(filename, "apple","stampcard", reader.result)

        if (index === 3) {
          let sid = _.cloneDeep(scannerInstanceData)
          _.set(sid,"__apple_image__", s3_url)
          setScannerInstanceData(sid)

          let id = _.cloneDeep(instanceData)
          _.set(id,"__scanner_data__.__apple_image__", s3_url)
          setInstanceData(id)
        }

        let sd = _.cloneDeep(scannerData)
        _.set(sd.stamp_images.apple, index, s3_url)
        setScannerData(sd)
      }
      reader.readAsDataURL(file)
    }

    return (
      <div key={index} className='flex flex-row justify-between items-center mb-5'>
        <Typography variant='h5'>{index}&nbsp;Stamps</Typography>
        <div className='flex items-center mr-2 ml-2' style={{ width: 1125 / 3, height: 432 / 3, backgroundSize:"100% 100%",backgroundRepeat: "no-repeat", border: "1px dashed", backgroundImage: "URL(" + scannerData.stamp_images.apple[index] +")" }}/>
        <FileUploader handleChange={handleImageUpload} types={["png", "jpg", "jpeg"]} children={AppleDropTargetContent}  />
      </div>
    )
  }

  const googleImageItem = index => {

    const filename = `google-stamp-${index}.png`

    const handleImageUpload = async file => {
      const reader = new FileReader()
      reader.onloadend = async () => {
        const s3_url = await doUploadToS3(filename, "google","stampcard", reader.result)

        if (index === 3) {
          let sid = _.cloneDeep(scannerInstanceData)
          _.set(sid,"__google_image__", s3_url)
          setScannerInstanceData(sid)

          let id = _.cloneDeep(instanceData)
          _.set(id,"__scanner_data__.__google_image__", s3_url)
          setInstanceData(id)
        }

        let sd = _.cloneDeep(scannerData)
        _.set(sd.stamp_images.google, index, s3_url)
        setScannerData(sd)
      }
      reader.readAsDataURL(file)
    }

    return (
      <div key={index} className='flex flex-row justify-between items-center mb-5'>
        <Typography variant='h4'>{index} Stamps</Typography>
        <div className='flex items-center' style={{ width: 1132 / 3, height: 366 / 3, backgroundSize:"100% 100%",backgroundRepeat: "no-repeat", border: "1px dashed", backgroundImage: "URL(" + scannerData.stamp_images.google[index] +")" }}/>
        <FileUploader handleChange={handleImageUpload} types={["png", "jpg", "jpeg"]} children={GoogleDropTargetContent} />
      </div>
    )
  }

  const appleImageItems = useMemo(() => {
    if (scannerData) {
      let items = []

      for (let i = 0; i <= scannerData?.stamps_per_card; i++) {
        items.push(appleImageItem(i))
      }

      return items
    }
  }, [scannerData, uploads])

  const googleImageItems = useMemo(() => {
    if (scannerData) {
      let items = []

      for (let i = 0; i <= scannerData?.stamps_per_card; i++) {
        items.push(googleImageItem(i))
      }

      return items
    }
  }, [scannerData, uploads])

  const doUploadToS3 = async (filename, device, imageType, imageData) => {

    // Convert to PNG if JPEG?

    const base64Data = imageData.replace(/^data:image\/\w+;base64,/, '')
    setProcessing(true)
    const response = await uploadClientImage({ apiSource, apiKeys, device, imageType, filename, base64Data })
    //TODO handler error

    setProcessing(false)
    setUploads(uploads + 1)

    return response.s3_url
  }


  useEffect(() => {
    setPrevButtonState("enabled")
    setNextButtonState("disabled")
  }, [])

  useEffect(() => {

    let valid = true

    if (valid) {
      setNextButtonState("enabled")
    } else {
      setNextButtonState("disabled")
    }
  }, [template, objectData, classData])

  return (
    <div className="mb-10">
      <Typography variant="h3" sx={{ p: 2 }}>Stampcard Images</Typography>
      <PassContext.Provider value={{ device: "apple", template, passType: applePassType, setTemplate, model, instanceData, setInstanceData, scannerInstanceData }}>
        <Typography variant="h4" sx={{ p: 2 }}>Apple Images</Typography>
        <hr className='mb-5' />
        <div>{appleImageItems}</div>
      </PassContext.Provider>

      <div className='mb-20' />

      <PassContext.Provider value={{ device: "google", passType: googlePassType, classData, objectData, setClassdata, setObjectData, instanceData, setInstanceData, scannerInstanceData }}>
        <Typography variant="h4" sx={{ p: 2 }}>Google Images</Typography>
        <hr className='mb-5' />
        <div>{googleImageItems}</div>
      </PassContext.Provider>
    </div>
  )
}

export default StampImages